module.exports = __webpack_public_path__ + "049c9d2b96f08af0221ec8bb93fe177f.svg";